(function () {
    'use strict';

    angular
        .module('app')
        .controller('PatternEditController', PatternEditController);

    function PatternEditController($scope, $rootScope, $filter, $timeout, $state, $stateParams, $q, $location,
        ImageUrl, UploadedImageUrl, ImageNotAvailableName, DefaultThumbnailSize, DefaultEnlargeSize, FileTypeExtImageUrl,
        WebAPIUrl, BriefService, PatternService, UserService, StatusService, WorkflowService,
        ImageService, SeasonService, toaster, LinePlanService, cfpLoadingBar , CarryoverService, WebApiService) {


        var model = this;
        model.currentUser = $rootScope.globals.currentUser;
        model.PatternRead = "";
        model.PatternEdit = "";
        model.PatternCreate = "";
        model.PatternDelete = "";
        model.PrototypeCreate = "";
        model.PatternRRAssignment = "";
        model.PatternStatusChange = "";
        model.PatternAdoptedStatusChange = "";
        model.isReadOnly = "";
        model.statusReadOnly = "";
        model.CanEditTargetPurchasePrice = !model.currentUser.isFactoryUser;
        model.CanViewFactoryFields = model.currentUser.isFactoryUser !== true;
        model.CanAddMaterials = false;
        model.PatternPTAEdit = false;
        model.PatternPTARead = false;
        model.PatternAdoptedStatusEdit = false;
        model.ImageUrl = ImageUrl;
        model.FileTypeExtImageUrl = FileTypeExtImageUrl;
        model.WebAPIUrl = WebAPIUrl;
        model.image = null;
        model.imageFileName = '';
        model.validImageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
        model.filesUploaded = 0;
        model.inValidFiles = 0;
        model.failedFiles = "";
        model.imageInterface = {};
        model.imageOutsoleInterface = {};
        model.disableAdoptStatus = true;
        model.carryoverShiftSeasonId = 0;
        model.carryoverShiftSeasons = [];
        model.carryoverShiftLinePlanId = 0;
        model.carryoverShiftLinePlans = [];
        model.carryoverShiftLinePlan = null;
        model.carryoverSuccess = false;
        model.carryoverFail = false;
        model.goToNewPattern = null;
        model.carryoverMessage = "";
        model.canShift = false;
        model.images = [];
        model.canCarryover = false;
        model.savePrototypes = false;
        $scope.userPermissionFlag = $rootScope.userPermissions;
        $scope.currentUserData = $rootScope.globals.currentUser;
        $scope.currentFactoryTargetPurchasePrice = !model.currentUser.isFactoryUser;
        $scope.currentFactoryField = model.currentUser.isFactoryUser !== true;
        $scope.currentImageUrl = model.ImageUrl
        $scope.currentFileTypeExtImageUrl = FileTypeExtImageUrl;
        $scope.currentPatternSeasonalId = $stateParams.patternSeasonalId;
        $scope.currentWebApiService = WebApiService;
        $scope.currentWebApiUrl = WebAPIUrl;
        $scope.currentUploadedImageUrl = UploadedImageUrl;
        $scope.currentDefaultThumbnailSize = DefaultThumbnailSize;
        $scope.currentDefaultEnlargeSize = DefaultEnlargeSize;
        $scope.currentImageNotAvailableName = ImageNotAvailableName;
        $scope.currentUserData = $rootScope.globals.currentUser;
        $scope.currentUserId= $rootScope.userId;
        $scope.currentUserFullName = $rootScope.fullName;
        $scope.urlId = $location.search().profile;
        $scope.userId = $scope.urlId || $rootScope.userId;
     
        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        // Listen for when the interface has been configured.
        $scope.$on('$dropletReady', function whenDropletReady() {
            model.imageInterface.allowedExtensions(['png', 'jpg', 'bmp', 'gif']);
            model.imageInterface.defineHTTPSuccess([/2.{2}/]);
            model.imageInterface.useArray(true);
        });

        $scope.status = {
            open: true,
            isFirstOpen: true,
            isFirstDisabled: false
        };

        $scope.clearHierCodeLevel = function (o, t) {
            model.patternDetails.HierCodeLev2Desc = "";
            model.patternDetails.HierCodeLev1Key = "";
        };

        model.getUser = function ($model) {
            if ($scope.patternEditForm.$dirty) {
                if (!$model) {
                    var nameCheck = false;
                    $scope.getUserResponse = false;
                    angular.forEach(model.users,
                        function (k) {
                            var name = model.patternSeasonalDetails.ResponsibleName.FullName
                                ? model.patternSeasonalDetails.ResponsibleName.FullName.toLowerCase()
                                : model.patternSeasonalDetails.ResponsibleName.toLowerCase();
                            if (name == k.FullName.toLowerCase() && !nameCheck) {
                                $scope.getUserResponse = true;
                                model.patternSeasonalDetails.ResponsibleId = k.Id;
                                model.patternSeasonalDetails.ResponsibleName = k.FullName; //assign name
                                nameCheck = true;
                            }
                        });
                } else {
                    $scope.getUserModel = $model;
                    //assign responsible id
                    model.patternSeasonalDetails.ResponsibleId = $scope.getUserModel.Id;
                    $scope.getUserResponse = true;
                }
                model.validateUser();
            }
        };

        model.validateUser = function () {
            $timeout(function () {
                if ($scope.getUserResponse) {
                    $scope.patternEditForm.rrAssignment.$setValidity('responsibleName', true);
                } else {
                    $scope.patternEditForm.rrAssignment.$setValidity('responsibleName', false);
                }
            }, 100);
        };

        model.usaDutyFree = function (t) {
            if (t)
                model.patternSeasonalDetails.TargetDtyUS = 0;
        };

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 4) {
                if (userPermissionRow[1] == 1) {
                    model.PatternRead = true;
                    model.PatternPTARead = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.PatternEdit = true;
                    $scope.editMode = true;
                }
                if (userPermissionRow[1] == 3) {
                    model.PatternCreate = true;
                }
                if (userPermissionRow[1] == 4) {
                    model.PatternStatusChange = true;
                }
                if (userPermissionRow[1] == 5) {
                    model.PatternRRAssignment = true;
                }
                if (userPermissionRow[1] == 6) {
                    model.PatternAdoptedStatusChange = true;
                }
                if (userPermissionRow[1] == 7) {
                    model.PatternDelete = true;
                }
            }

            //Prototype permissions
            if (userPermissionRow[0] == 5) {
                if (userPermissionRow[1] == 3) {
                    model.PrototypeCreate = true;
                }
            }

            //PTA Permissions
            if (userPermissionRow[0] === 4 && userPermissionRow[1] === 9) {
                model.PatternPTAEdit = true;
            }

            //Adopted Status Permission
            if (userPermissionRow[0] === 4 && userPermissionRow[1] === 6) {
                model.PatternAdoptedStatusEdit = true;
            }

            if (userPermissionRow[0] === 9 && userPermissionRow[1] === 2) {
                model.CanAddMaterials = true;
            }

        });

        if (!model.PatternRead && !model.PatternEdit) {
            $state.go('permissionDenied');
        }

        model.patternSeasonalId = $stateParams.patternSeasonalId;

        /*StatusService.isRecordDeleted(3, model.patternSeasonalId)
            .then(function (response) {
                if (response == true) {
                    toaster.pop({
                        type: 'note',
                        title: 'Pattern Deleted',
                        body: 'The Pattern you are trying to access is deleted.',
                        timeout: 5000
                    });
                    $state.go('Search');
                }
            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error',
                        body: 'Please contact your System Administrator.',
                        timeout: 5000
                    });
                    $state.go('Search');
                });*/

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        }

        function getUsers() {
            UserService.getUsersByBrand(model.patternDetails.BrandId).then(function (data) {
                model.users = data;
            });
        }

        function getGroupList(currentBrandId) {
            WorkflowService.getWFGroups(model.patternDetails.BrandId, 3).then(function (data) {
                model.groupList = data;
            });
        }

        function getStatusList(currentStatusId) {
            StatusService.getAvailableStatusList(currentStatusId).then(function (data) {
                model.statusList = data;
            });
        }

        function getDevelopmentTypeList(isNew) {
            PatternService.getDevelopmentTypeList(isNew).then(function (data) {
                model.developmentTypeList = data;
            });
        }

        function getFabricBottomOutsoleList() {
            PatternService.getFabricBottomOutsoleList().then(function (data) {
                model.fabricBottomOutsoleList = data;
            });
        }

        function getProductLineList() {
            PatternService.getProductLineList().then(function (data) {
                model.productLineList = data;
            });
        }

        function getSeasonalProgramList() {
            PatternService.getSeasonalProgramList().then(function (data) {
                model.seasonalProgramList = data;
            });
        }

        function getOffsetList() {
            PatternService.getOffsetList().then(function (data) {
                angular.forEach(data, function (k, v) {
                    k.Description = parseInt(k.Description);
                })
                model.offsetList = data;
            });
        }

        function getMembraneSupplierList() {
            PatternService.getMembraneSupplierList().then(function (data) {
                model.membraneSupplierList = data;
            });
        }

        function getMembranePackageList() {
            PatternService.getMembranePackageList().then(function (data) {
                model.membranePackageList = data;
            });
        }

        function getOriginalAdoptedDate() {
            PatternService.getOriginalAdoptedDate(model.patternDetails.PatternId, model.patternSeasonalDetails.SeasonId, model.patternDetails.PatternNameKey, model.patternDetails.GenderKey).then(function (data) {
                model.patternSeasonalDetails.OriginalAdoptedDate = data;
            });
        }

        function imagePopulation(a, b, id) {
            var exists = model.images.map(function (e, v) { return e.id }).indexOf(id);
            a !== ImageNotAvailableName && id == 1 && exists === -1 ? model.images.push({ id: 1, label: 'Product Image', name: 'ImageName', selected: false }) : '';
            b !== ImageNotAvailableName && id == 2 && exists === -1 ? model.images.push({ id: 2, label: 'Outsole Image', name: 'OutsoleImageName', selected: false }) : '';
        }

        /*function getPatternSeasonalDetails() {
            PatternService.getPatternSeasonalDetails(model.patternSeasonalId).then(function (response) {
                if (response === null) {
                    $state.go('permissionDenied');
                    return;
                }

                model.patternSeasonalDetails = response;
                model.patternCurrStatusId = model.patternSeasonalDetails.StatusId;

                $scope.patternId = model.patternSeasonalDetails.PatternId;
                getDevelopmentTypeList(model.patternSeasonalDetails.IsNew);
                getFabricBottomOutsoleList();
                getProductLineList();
                getSeasonalProgramList();
                getOffsetList();
                getMembraneSupplierList();
                getMembranePackageList();

                //Get Status List
                getStatusList(model.patternSeasonalDetails.StatusId);

                PatternService.canPatternCarryover(model.patternSeasonalDetails.PatternSeasonalId).then(function (response) {
                    model.canCarryover = response;
                });

                //Get Pattern Details
                PatternService.getPatternDetails(model.patternSeasonalDetails.PatternId).then(function (patternDetails) {
                    model.patternDetails = patternDetails;
                    getBrandPermissions(model.patternDetails.BrandId);

                    //Get Current Pattern Details for Search Help validation

                    model.PreviousPatternName = model.patternDetails.PatternName;
                    model.PreviousLastName = model.patternDetails.LastName;
                    model.PreviousOutsoleName = model.patternSeasonalDetails.OutsoleName;
                    model.PreviousMidsoleName = model.patternSeasonalDetails.MidsoleName;
                    model.PreviousCustomerName = model.patternDetails.CustomerNam;
                    model.PreviousActivityType = model.patternDetails.ActivityType;
                    model.PreviousSBU = model.patternDetails.SBU;
                    model.PreviousConstruction = model.patternDetails.Construction;
                    model.PreviousProductHierarchy = model.patternDetails.HierCodeLev2Desc;
                    model.PreviousMaterialFGRPDesc = model.patternDetails.MatlFrGrpDesc;
                    model.PreviousCompound = model.patternDetails.CompounDesc;
                    model.PreviousMembraneDesc = model.patternDetails.MembraneDesc;
                    model.PreviousPlanningCategory = model.patternDetails.PlanningCatDesc;

                    if (model.patternSeasonalDetails.StatusId == 3 || model.patternSeasonalDetails.StatusId == 4 || model.patternSeasonalDetails.StatusId == 5 || model.patternSeasonalDetails.StatusId == 6 || model.patternSeasonalDetails.StatusId == 7) {
                        model.isReadOnly = true;
                    }
                    else {
                        model.isReadOnly = false;
                    }

                    model.sapBrandId = model.patternDetails.SAPBrandId;
                    model.patternDetails.ImagePath = model.patternDetails.ImagePath ? model.patternDetails.ImagePath.trim() : '';
                    model.patternDetails.ImagePath === "" && model.patternDetails.ImageName === "" ? model.patternDetails.ImagePath = ImageNotAvailableName : '';

                    //set image name
                    model.uploadedPatternImage = UploadedImageUrl + model.patternDetails.ImagePath + model.patternDetails.ImageName;
                    model.patternImage = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultThumbnailSize;

                    model.patternImageFull = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=1"
                        + "&size=" + DefaultEnlargeSize;

                    if (model.patternDetails.OutsoleImagePath == null) {
                        model.patternDetails.OutsoleImagePath = '';
                    }

                    model.uploadedOutsoleImage = UploadedImageUrl + model.patternDetails.OutsoleImagePath + model.patternDetails.OutsoleImageName;
                    model.outsoleImage = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=2"
                        + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');

                    model.outsoleImageFull = ImageUrl
                        + "?projectId=" + model.patternDetails.PatternId
                        + "&projectLevel=3"
                        + "&imageType=2"
                        + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(model.patternDetails.ChangedOn, 'MMddyyHHmmss');

                    imagePopulation(model.patternDetails.ImageName, model.patternDetails.OutsoleImageName, 1); //populate image criteria for deletion
                    imagePopulation(model.patternDetails.ImageName, model.patternDetails.OutsoleImageName, 2); //populate image criteria for deletion

                    //Get Users
                    getUsers();

                    getGroupList(model.patternDetails.PatternId);

                    //Check if pattern is dual sourced
                    PatternService.isDualSourced(model.patternSeasonalId).then(function (dualSourcedResponse) {
                        model.isDualSourced = dualSourcedResponse;
                    });

                    //Check if pattern can be adopted only if pattern seasonal status is released
                    if (model.patternSeasonalDetails.StatusId == 2) {
                        PatternService.CanAdopt(model.patternDetails.PatternId, model.patternSeasonalDetails.SeasonId)
                            .then(function (response) {
                                if (response == true) {
                                    model.disableAdoptStatus = false;
                                }
                            });
                    }
                    //Get Pattern Spec Log Data for same season by pattern key
                    PatternService.getSpecLogData(model.patternDetails.PatternId, 3, model.patternSeasonalDetails.SeasonId, model.patternDetails.PatternNameKey, 1).then(function (specLogDataResponse) {
                        model.specLogData = specLogDataResponse;
                    });

                    //Get Pattern Spec Log Data for different season by pattern key
                    PatternService.getSpecLogData(model.patternDetails.PatternId, 3, model.patternSeasonalDetails.SeasonId, model.patternDetails.PatternNameKey, 0).then(function (specLogDataResponse1) {
                        model.specLogDataDiffSeason = specLogDataResponse1;
                    });


                    PatternService.getAllDevelopersList(model.patternDetails.BrandId, true).then(function (data) {

                        model.designerList = PatternService.filterDevelopersByRole(data, 1, model.patternDetails.Designer, true);
                        model.developerList = PatternService.filterDevelopersByRole(data, 2, model.patternDetails.Developer, true);
                        model.sourcingDeveloperList = PatternService.filterDevelopersByRole(data, 3, model.patternDetails.SourcDeveloper, true);
                        model.contractDesignerList = PatternService.filterDevelopersByRole(data, 4, model.patternDetails.ContrctDesigner, true);
                        model.coloristList = PatternService.filterDevelopersByRole(data, 5, model.patternDetails.Colorist, true);
                    });

                    PatternService.canPatternShiftSeason(model.patternDetails.PatternId).then(function (data) {
                        model.canShift = data;
                    });

                    getOriginalAdoptedDate();
                    getSeasonList();
                });

                //log to last used
                var lastUsedModel = {
                    UserId: $rootScope.userId,
                    ProjectId: model.patternSeasonalDetails.PatternSeasonalId,
                    ProjectLevelId: 3
                };
                UserService.logLastUseProject(lastUsedModel);
            });
        };*/

        /*getPatternSeasonalDetails();*/

        //Manage Adoption status
        model.manageAdoptionStatus = function () {
            if (model.patternSeasonalDetails.StatusId == 2) {
                PatternService.CanAdopt(model.patternDetails.PatternId, model.patternSeasonalDetails.SeasonId)
                    .then(function (response) {
                        if (response == true) {
                            model.disableAdoptStatus = false;
                        }
                    });
            }
        };

        model.PatternGenderCombinationExists = function (patternNameKey, genderKey, showToastMessage) {
            var deferred = $q.defer();
            PatternService.GetPatternByBrandNameGender(patternNameKey, genderKey, model.patternDetails.BrandId, model.patternDetails.PatternId).then(
                function (response) {
                    var exists = response != null;
                    if (exists && showToastMessage) {
                        toaster.pop({ body: "Pattern Key and Gender Key combination already exists on project: " + response.Name, type: "error", title: "Error!", timeout: 10000 });
                    }
                    deferred.resolve(exists, response);
                });

            return deferred.promise;
        };

        model.factoryGroupNameAndKey = function () {
            var f = '';
            if (model.patternDetails && model.patternDetails.FactoryGroupName) {
                f = model.patternDetails.FactoryGroupName
                if (model.patternDetails.FactoryGroupKey && model.patternDetails.FactoryGroupKey.length > 0) {
                    f += " (" + model.patternDetails.FactoryGroupKey + ")";
                }
            }
            return f;
        }

        function saveAfter(dontSave) {
            model.needToValidate = false; //no more need to validate since this runs after call to SAP is complete
            if ($scope.saveClicked) { //will only run this if save was clicked
                if (dontSave) { //reset saveClicked after save is compelte (only call on save return)
                    //debugger;
                    $scope.saveClicked = false;
                } else {
                    //if save was clicked but dontSave is false
                    model.Save($scope.patternEditForm.$invalid); //run the save
                }
            }
        }

        model.updateAdoptedDetails = function () {
            $scope.patternEditForm.$setValidity('adoptStatusValid', true);
            if (model.patternDetails.AdoptedStatus == false) {
                model.patternDetails.AdoptedDate = "";
                model.patternDetails.AdoptedBy = "";
                model.patternDetails.AdoptedByName = "";
            }
            else {
                PatternService.CanAdopt(model.patternDetails.PatternId, model.patternSeasonalDetails.SeasonId)
                    .then(function (response) {
                        if (response == true) {
                            model.patternDetails.AdoptedDate = moment.utc().format();
                            model.patternDetails.AdoptedBy = $rootScope.userId;
                            model.patternDetails.AdoptedByName = $rootScope.fullName;
                        }
                        else {
                            model.patternDetails.AdoptedStatus = false;
                            $scope.patternEditForm.$setValidity('adoptStatusValid', false);
                        }
                    });
            }
        };

        model.PTAUpdate = function () {
            if (model.PatternPTAEdit) {
                if (model.patternDetails.PTAStatus) {
                    model.patternDetails.PTAStatus = false;
                    model.patternDetails.PTAAuthDate = null;
                    model.patternDetails.PTAAuthBy = null;
                } else {
                    model.patternDetails.PTAStatus = true;
                    model.patternDetails.PTAAuthDate = $filter('date')(new Date(), 'MM/dd/yy');
                    model.patternDetails.PTAAuthBy = $rootScope.userId;
                    model.patternDetails.PTAAuthByName = $rootScope.fullName;
                }
            }
        }

        model.AdoptedClick = function (patternEditForm) {
            if (model.PatternAdoptedStatusEdit && !model.disableAdoptStatus) {
                model.patternDetails.AdoptedStatus = !model.patternDetails.AdoptedStatus;
                model.updateAdoptedDetails();
                patternEditForm.$setDirty();
            }
        };

        //clear waterproof related fields if waterproof is unchecked
        model.UpdateWaterproofRelatedFields = function () {
            if (!model.patternDetails.Waterproof) {
                model.patternDetails.Membrane = false;
                model.patternDetails.MembrnSupp = "";
                model.patternDetails.MembraneDesc = "";
                model.patternDetails.MembrnKey = "";
                model.patternDetails.MembrnPckg = "";
                model.patternDetails.BootieYn = false;
                model.patternDetails.SeamSldYn = false;
            }
        };

        model.calculateTotalVolumes = function () {
            var intlVol = 0;

            if (!isNaN(parseFloat(model.patternSeasonalDetails.Emea3pVolume))) {
                intlVol += parseFloat(model.patternSeasonalDetails.Emea3pVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.AsiaVolume))) {
                intlVol += parseFloat(model.patternSeasonalDetails.AsiaVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.LatinAVolume))) {
                intlVol += parseFloat(model.patternSeasonalDetails.LatinAVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.EmeaDistVolume))) {
                intlVol += parseFloat(model.patternSeasonalDetails.EmeaDistVolume);
            }

            model.patternSeasonalDetails.IntnlVolume = intlVol;

            model.calculateTotalVolume();
        };

        model.calculateTotalVolume = function () {
            var estimatedVol = 0;

            if (!isNaN(parseFloat(model.patternSeasonalDetails.USVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.USVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.EmeaDistVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.EmeaDistVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.CAVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.CAVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.NaDtcStoreVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.NaDtcStoreVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.NaDtcEcomVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.NaDtcEcomVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.EuDtcVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.EuDtcVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.EmeaOwnedVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.EmeaOwnedVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.Emea3pVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.Emea3pVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.AsiaVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.AsiaVolume);
            }
            if (!isNaN(parseFloat(model.patternSeasonalDetails.LatinAVolume))) {
                estimatedVol += parseFloat(model.patternSeasonalDetails.LatinAVolume);
            }

            model.patternSeasonalDetails.TotalVolume = estimatedVol;
        };

        model.checkPatternName = function (scope) {
            //scope.patternEditForm.patternName.$setValidity('PatternNameExists', true);
            toaster.clear();
            PatternService.isPatternNameExists(model.patternSeasonalDetails.PatternId, model.patternDetails.Name, model.patternDetails.BrandId, model.patternSeasonalDetails.SeasonId)
                .then(function (response) {
                    if (response == true) {
                        //scope.patternEditForm.patternName.$setValidity('PatternNameExists', false);
                        toaster.pop({
                            type: 'note',
                            title: 'Name Duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 10000
                        });
                    }
                });
        };

        //Save Pattern Header and Details
        model.Save = function (isFormInvalid) {
            $scope.saveClicked = true;
            if (model.needToValidate) {
                return;
            }

            if (!isFormInvalid) {
                $scope.patternEditForm.$setPristine();
                var accountableId = model.patternSeasonalDetails.ResponsibleId;
                var statusId = model.patternSeasonalDetails.StatusId;
                var adoptedStatus = model.patternDetails.AdoptedStatus;
                var wfGroupId = model.patternSeasonalDetails.WFGroupId;

                if (model.PatternRRAssignment) {
                    if (model.patternSeasonalDetails.ResponsibleName.Id) {
                        accountableId = model.patternSeasonalDetails.ResponsibleName.Id;
                    }
                }

                if (model.PatternStatusChange) {
                    statusId = model.patternSeasonalDetails.StatusId;
                }

                if (model.PatternAdoptedStatusChange) {
                    adoptedStatus = model.patternSeasonalDetails.AdoptedStatus;
                }

                if (!model.patternSeasonalDetails.OrigFOBTarget && model.patternSeasonalDetails.TargetPurPrice) {
                    model.patternSeasonalDetails.OrigFOBTarget = model.patternSeasonalDetails.TargetPurPrice;
                }

                if (accountableId == 'undefined' || accountableId != null || accountableId != "") {

                    var patternEstCompletionDate = "";
                    var patternActualCompletionDate = "";

                    if (model.patternDetails.EstCompleteDate) {
                        patternEstCompletionDate = $filter('date')(model.patternDetails.EstCompleteDate, "short");
                    }

                    if (model.patternDetails.ActCompleteDate) {
                        patternActualCompletionDate = $filter('date')(model.patternDetails.ActCompleteDate, "short");
                    }

                    //console.log('Adopted: ' + model.patternDetails.AdoptedDate);

                    model.patternData = {
                        PatternId: model.patternDetails.PatternId,
                        BrandId: model.patternDetails.BrandId,
                        Name: model.patternDetails.Name,
                        AdoptedStatus: model.patternDetails.AdoptedStatus,
                        AdoptedDate: model.patternDetails.AdoptedDate,
                        AdoptedBy: model.patternDetails.AdoptedBy,
                        EstCompleteDate: patternEstCompletionDate,
                        ActCompleteDate: patternActualCompletionDate,
                        ReferencePattern: model.patternDetails.ReferencePattern,
                        ApprovalNumber: model.patternDetails.ApprovalNumber,
                        Stage1: model.patternDetails.Stage1,
                        Stage2: model.patternDetails.Stage2,
                        Stage3: model.patternDetails.Stage3,
                        DevRefName: model.patternDetails.DevRefName,
                        DivisionKey: model.patternDetails.DivisionKey,
                        Division: model.patternDetails.Division,
                        PatternNameKey: model.patternDetails.PatternNameKey,
                        PatternName: model.patternDetails.PatternName,
                        PatternDesc: model.patternDetails.PatternDesc,
                        LastNameKey: model.patternDetails.LastNameKey,
                        LastName: model.patternDetails.LastName,
                        LastDescr: model.patternDetails.LastDescr,
                        NewLastYN: model.patternDetails.NewLastYN,
                        MktgOutsoleNm: model.patternDetails.MktgOutsoleNm,
                        FabBtmOutsole: model.patternDetails.FabBtmOutsole,
                        HeelHeight: model.patternDetails.HeelHeight,
                        ShaftHeight: model.patternDetails.ShaftHeight,
                        ShaftCircum: model.patternDetails.ShaftCircum,
                        Offset: model.patternDetails.Offset,
                        ForefootHght: model.patternDetails.ForefootHght,
                        DiamAlphaNum: model.patternDetails.DiamAlphaNum,
                        ActivityType: model.patternDetails.ActivityType,
                        ActivityKey: model.patternDetails.ActivityKey,
                        ProductLine: model.patternDetails.ProductLine,
                        SeasonalPrgm: model.patternDetails.SeasonalPrgm,
                        CustomerKey: model.patternDetails.CustomerKey,
                        CustomerNam: model.patternDetails.CustomerNam,
                        ConsumSupport: model.patternDetails.ConsumSupport,
                        InStorePgrm: model.patternDetails.InStorePgrm,
                        TechCallout: model.patternDetails.TechCallout,
                        SellinSuprt: model.patternDetails.SellinSuprt,
                        VeganFriend: model.patternDetails.VeganFriend,
                        ConstructionKey: model.patternDetails.ConstructionKey,
                        Construction: model.patternDetails.Construction,
                        GenderKey: model.patternDetails.GenderKey,
                        Gender: model.patternDetails.Gender,
                        CollectionNum: model.patternDetails.CollectionNum,
                        CollectionDesc: model.patternDetails.CollectionDesc,
                        HierCodeLev1Key: model.patternDetails.HierCodeLev1Key,
                        HierCodeLev2Desc: model.patternDetails.HierCodeLev2Desc,
                        MatlFrGrpKy: model.patternDetails.MatlFrGrpKy,
                        MatlFrGrpDesc: model.patternDetails.MatlFrGrpDesc,
                        Developer: model.patternDetails.Developer,
                        SourcDeveloper: model.patternDetails.SourcDeveloper,
                        Designer: model.patternDetails.Designer,
                        FactAccessKey: model.patternDetails.FactAccessKey,
                        FactAccessName: model.patternDetails.FactAccessName,
                        FactoryGroupKey: model.patternDetails.FactoryGroupKey,
                        FactoryGroupName: model.patternDetails.FactoryGroupName, 
                        RetailPrice: model.patternDetails.RetailPrice,
                        WsPrice: model.patternDetails.WsPrice,
                        BusinessSeg: model.patternDetails.BusinessSeg,
                        VibramYN: model.patternDetails.VibramYN,
                        CompoundKy: model.patternDetails.CompoundKy,
                        CompounDesc: model.patternDetails.CompounDesc,
                        Waterproof: model.patternDetails.Waterproof,
                        Membrane: model.patternDetails.Membrane,
                        MembrnSupp: model.patternDetails.MembrnSupp,
                        MembrnKey: model.patternDetails.MembrnKey,
                        MembraneDesc: model.patternDetails.MembraneDesc,
                        MembrnPckg: model.patternDetails.MembrnPckg,
                        BootieYn: model.patternDetails.BootieYn,
                        SeamSldYn: model.patternDetails.SeamSldYn,
                        UpperLining: model.patternDetails.UpperLining,
                        MidsleOutsle: model.patternDetails.MidsleOutsle,
                        GenNotes: model.patternDetails.GenNotes,
                        ContrctDesigner: model.patternDetails.ContrctDesigner,
                        Colorist: model.patternDetails.Colorist,
                        SBU: model.patternDetails.SBU,
                        PlanningCatDesc: model.patternDetails.PlanningCatDesc,
                        PlanningCatKey: model.patternDetails.PlanningCatKey,
                        SampleWeight: model.patternDetails.SampleWeight,
                        SBUKey: model.patternDetails.SBUKey,
                        IsLocked: model.patternDetails.IsLocked,
                        PTAStatus: model.patternDetails.PTAStatus,
                        PTAAuthDate: model.patternDetails.PTAAuthDate,
                        PTAAuthBy: model.patternDetails.PTAAuthBy
                    };

                    model.patternSeasonalData = {
                        PatternSeasonalId: model.patternSeasonalDetails.PatternSeasonalId,
                        StatusId: statusId,
                        ResponsibleId: accountableId,
                        NewKnivesYN: model.patternSeasonalDetails.NewKnivesYN,
                        OrigFOBTarget: model.patternSeasonalDetails.OrigFOBTarget,
                        TargetPurPrice: model.patternSeasonalDetails.TargetPurPrice,
                        StyleMin: model.patternSeasonalDetails.StyleMin,
                        ProjPattVol: model.patternSeasonalDetails.ProjPattVol,
                        USVolume: model.patternSeasonalDetails.USVolume,
                        CAVolume: model.patternSeasonalDetails.CAVolume,
                        EmeaOwnedVolume: model.patternSeasonalDetails.EmeaOwnedVolume,
                        EmeaDistVolume: model.patternSeasonalDetails.EmeaDistVolume,
                        NaDtcStoreVolume: model.patternSeasonalDetails.NaDtcStoreVolume,
                        NaDtcEcomVolume: model.patternSeasonalDetails.NaDtcEcomVolume,
                        ItalyVolume: model.patternSeasonalDetails.ItalyVolume,
                        EuDtcVolume: model.patternSeasonalDetails.EuDtcVolume,
                        Emea3pVolume: model.patternSeasonalDetails.Emea3pVolume,
                        AsiaVolume: model.patternSeasonalDetails.AsiaVolume,
                        CNVolume: model.patternSeasonalDetails.CNVolume,
                        HKVolume: model.patternSeasonalDetails.HKVolume,
                        C4CVolume: model.patternSeasonalDetails.C4CVolume,
                        LatinAVolume: model.patternSeasonalDetails.LatinAVolume,
                        IntnlVolume: model.patternSeasonalDetails.IntnlVolume,
                        TotalVolume: model.patternSeasonalDetails.TotalVolume,
                        TargetNumColors: model.patternSeasonalDetails.TargetNumColors,
                        TargetDtyUS: model.patternSeasonalDetails.TargetDtyUS,
                        USDutyFree: model.patternSeasonalDetails.USDutyFree,
                        TargetDtyCA: model.patternSeasonalDetails.TargetDtyCA,
                        TargetDtyUK: model.patternSeasonalDetails.TargetDtyUK,
                        TargetDtyEU: model.patternSeasonalDetails.TargetDtyEU,
                        DevelopmentType: model.patternSeasonalDetails.DevelopmentType,
                        OutsoleNumber: model.patternSeasonalDetails.OutsoleNumber,
                        OutsoleName: model.patternSeasonalDetails.OutsoleName,
                        OutsoleTechID: model.patternSeasonalDetails.OutsoleTechID,
                        OutsoleTechDesc: model.patternSeasonalDetails.OutsoleTechDesc,
                        MidsoleNumber: model.patternSeasonalDetails.MidsoleNumber,
                        MidsoleName: model.patternSeasonalDetails.MidsoleName,
                        WFGroupId: wfGroupId
                    };


                    model.specLogData = { ProjectId: model.patternDetails.PatternId, ProjectLevelId: 3, Description: model.specLogDescription, SeasonId: model.patternSeasonalDetails.SeasonId, PatternNameKey: model.patternDetails.PatternNameKey, CreatedBy: $rootScope.userId };

                    PatternService.updatePattern(model.patternData, model.patternSeasonalData, model.specLogData, model.savePrototypes, model.selectedDevCenters)
                        .then(function (response) {
                            if (response.IsSuccessful) {
                                toaster.pop({
                                    type: 'success',
                                    title: 'Success!',
                                    body: 'Record Saved Successfully.',
                                    timeout: 5000
                                });

                                //clear spec log text box
                                model.specLogDescription = "";

                                //Get Pattern Spec Log Data for same season by pattern key
                                PatternService.getSpecLogData(model.patternDetails.PatternId, 3, model.patternSeasonalDetails.SeasonId, model.patternDetails.PatternNameKey, 1).then(function (specLogDataResponse) {
                                    model.specLogData = specLogDataResponse;
                                });

                                //Get Pattern Spec Log Data for different season by pattern key
                                PatternService.getSpecLogData(model.patternDetails.PatternId, 3, model.patternSeasonalDetails.SeasonId, model.patternDetails.PatternNameKey, 0).then(function (specLogDataResponse1) {
                                    model.specLogDataDiffSeason = specLogDataResponse1;
                                });

                                getPatternSeasonalDetails();
                                model.updateDirectives = model.updateDirectives ? false : true;
                            }
                            else {
                                toaster.pop({
                                    type: 'error',
                                    title: 'Error!',
                                    body: response.Message,
                                    timeout: 5000
                                });
                            }
                            $scope.saveClicked = false; //this re-enables the save button
                            $scope.patternEditForm.$setPristine();
                            $scope.patternEditForm.$setUntouched();
                        }, function (error, status) {
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: error,
                                timeout: 5000
                            });
                            $scope.saveClicked = false; //this re-enables the save button
                            $scope.patternEditForm.$setPristine();
                            $scope.patternEditForm.$setUntouched();
                        });
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'User Id missing.',
                        timeout: 5000
                    });
                }
            }
            else {
                if (!model.needToValidate) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Please review all fields indicated in red',
                        timeout: 5000
                    });
                    saveAfter(true);
                }
            }
        }

        /*Start of Upload Image Section*/
        function clearImageUpload() {
            model.imageInterface = {};
            document.getElementById('file').value = null;
        }

        //Browse Image and Upload
        model.checkImageTypeValidation = function () {
            $scope.patternEditForm.imageTypeField.$setValidity('imageTypeRequired', true);
            if (!model.imageType) {
                $scope.patternEditForm.imageTypeField.$setValidity('imageTypeRequired', false);
            }
        };

        $scope.imageCapture = function (e) {
            var imgArray;

            if (typeof e.files == 'undefined') {
                imgArray = e.file;
            } else {
                imgArray = e.files[0];
            }

            var ext = imgArray.name.substr(imgArray.name.lastIndexOf('.') + 1).toLowerCase();
            var errors = 0;
            //asdfasdf
            if (model.validImageExtensions.indexOf(ext) == -1) {
                errors++;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Invalid File Format',
                    timeout: 5000
                });
            }

            if (imgArray.name.length > 175) {
                errors++;
                var a = file.files[0].name.length - 175;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'File name is ' +
                        a +
                        ' characters over the maximum amount of 175. Please rename your file, and try again.',
                    timeout: 5000
                });
                //remove file from droplet
                clearImageUpload();
            }

            if (errors == 0) {
                $scope.showHideImgUpload(true);
                $scope.image = imgArray;
            }

            $scope.patternEditForm.$setPristine();
            $scope.patternEditForm.$setUntouched();
        };

        $scope.selectImageCategory = function (e) {
            //e = category id, this is set in the tpl.html file for pattern
            model.imageType = e;
            if (model.imageType) {
                uploadImage($scope.image);
            }
        };

        $scope.showHideImgUpload = function (e) {
            $scope.showImageCategory = e;
        };

        //Upload Image
        function uploadImage(file) {
            $scope.patternEditForm.$setDirty();

            if (model.imageType == 1) {
                model.patternImage = "";
            }
            if (model.imageType == 2) {
                model.patternOutsoleImage = "";
            }

            var imageMeta = {
                ProjectId: model.patternSeasonalDetails.PatternId,
                ProjectLevel: 3,
                ImageType: model.imageType
            };

            ImageService.uploadImage(file, imageMeta)
                .then(function (response) {
                    //remove file from droplet
                    clearImageUpload();

                    if (model.imageType == 1) {
                        model.uploadedPatternImage = UploadedImageUrl + response.ImagePath + response.ImageName;
                        model.patternImage = ImageUrl
                            + "?projectId=" + model.patternDetails.PatternId
                            + "&projectLevel=3"
                            + "&imageType=1"
                            + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                        model.patternImageFull = ImageUrl
                            + "?projectId=" + model.patternDetails.PatternId
                            + "&projectLevel=3"
                            + "&imageType=1"
                            + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');
                        imagePopulation(model.patternImage, model.patternDetails.OutsoleImageName, 1); //populate image criteria for deletion

                    }
                    else if (model.imageType == 2) {
                        model.uploadedOutsoleImage = UploadedImageUrl + response.ImagePath + response.ImageName;
                        model.outsoleImage = ImageUrl
                            + "?projectId=" + model.patternDetails.PatternId
                            + "&projectLevel=3"
                            + "&imageType=2"
                            + "&size=" + DefaultThumbnailSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                        model.outsoleImageFull = ImageUrl
                            + "?projectId=" + model.patternDetails.PatternId
                            + "&projectLevel=3"
                            + "&imageType=1"
                            + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(new Date(), 'MMddyyHHmmss');

                        imagePopulation(model.patternDetails.ImageName, model.outsoleImage, 2); //populate image criteria for deletion

                    }

                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Image uploaded successfully',
                        timeout: 3000
                    });

                    $scope.showHideImgUpload(false);

                }, function (error, status) {
                    model.patternImage = ImageUrl + model.patternDetails.ImagePath + model.patternDetails.ImageName;
                    model.patternOutsoleImage = ImageUrl + model.patternDetails.OutsoleImagePath + model.patternDetails.OutsoleImageName;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: "There was an error while uploading the image. Please contact system administrator. Error Message: " + error.ExceptionMessage,
                        timeout: 3000
                    });
                    $scope.showHideImgUpload(false);
                    clearImageUpload();
                });
            $scope.patternEditForm.$setPristine();
            $scope.patternEditForm.$setUntouched();
        }

        model.deleteImage = function (projectId, projectLevel, imageType) {
            ImageService.deleteImage(projectId, projectLevel, imageType)
                .then(function (response) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: "Image Deleted Successfully",
                        timeout: 5000
                    });

                    var imageToRemoveIndex = model.images.map(function (e) { return e.id; }).indexOf(imageType);
                    model.images.splice(imageToRemoveIndex, 1);

                    if (model.imagesToDelete.length > 0) {
                        var date = new Date();
                        var t = date.getTime();
                        if (model.imagesToDelete[0] == 1) {
                            //current
                            model.uploadedPatternImage = UploadedImageUrl + ImageNotAvailableName;
                            //thumbnail
                            model.patternImage = ImageUrl + "?projectId=" + model.patternDetails.PatternId + "&projectLevel=3" + "&imageType=1" + "&size=" + DefaultThumbnailSize + '&t=' + t;
                            //enlarged
                            model.patternImageFull = ImageUrl + "?projectId=" + model.patternDetails.PatternId + "&projectLevel=3" + "&imageType=1" + "&size=" + DefaultEnlargeSize + '&t=' + t;
                        }
                        if (model.imagesToDelete[0] == 2) {
                            //current
                            model.uploadedOutsoleImage = UploadedImageUrl + ImageNotAvailableName;
                            //thumbnail
                            model.outsoleImage = ImageUrl + "?projectId=" + model.patternDetails.PatternId + "&projectLevel=3" + "&imageType=2" + "&size=" + DefaultThumbnailSize + '&t=' + t;
                            //enlarged
                            model.outsoleImageFull = ImageUrl + "?projectId=" + model.patternDetails.PatternId + "&projectLevel=3" + "&imageType=2" + "&size=" + DefaultEnlargeSize + '&t=' + t;
                        }
                        model.imagesToDelete.splice(0, 1); //remove from array
                    }

                    if (model.imagesToDelete.length > 0) {
                        model.deleteImage(model.patternDetails.PatternId, 3, model.imagesToDelete[0]);
                    }

                },
                    function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: "There was an error while deleting the image. Please contact system administrator.",
                            timeout: 5000
                        });
                    });
        };

        model.deleteMultipleImages = function () {
            model.imagesToDelete = [];

            //build imagesToDelete for synchronous deletion
            for (var i = 0; i < model.images.length; i++) {
                if (model.images[i].selected) {
                    model.imagesToDelete.push(model.images[i].id);
                }
            }

            if (model.imagesToDelete.length > 0) {
                model.deleteImage(model.patternDetails.PatternId, 3, model.imagesToDelete[0]);
            }
        };

        model.refreshImageCache = function () {
            $scope.refreshingImage = true;

            var imgUrl = model.patternImage + "&r=" + Math.random();
            var imgFullUrl = model.patternImageFull + "&r=" + Math.random();
            var outsoleImgUrl = model.outsoleImage + "&r=" + Math.random();
            var outsoleImgFullUrl = model.outsoleImageFull + "&r=" + Math.random();

            model.patternImage = ImageService.defaultImageUrl(DefaultThumbnailSize);
            model.patternImageFull = ImageService.defaultImageUrl(DefaultEnlargeSize);
            model.outsoleImage = ImageService.defaultImageUrl(DefaultThumbnailSize);
            model.outsoleImageFull = ImageService.defaultImageUrl(DefaultEnlargeSize);

            ImageService.invalidateCache(model.patternDetails.PatternId, 3).then(function () {
                WebApiService.get(imgUrl).then(function () {
                    model.patternImage = imgUrl;
                    model.patternImageFull = imgFullUrl;
                    model.outsoleImage = outsoleImgUrl;
                    model.outsoleImageFull = outsoleImgFullUrl;
                    $scope.refreshingImage = false;
                });
            });
        };

        //Action Items events
        model.List = function () {
            $state.go("patternList");
        };

        model.Copy = function () {
            $state.go("patternCopy", { parentPatternSeasonalId: model.patternSeasonalId });
        };

        model.CreatePrototype = function () {
            if (model.canCreatePrototype())
                $state.go("projectCreate", { patternSeasonalId: model.patternSeasonalId });
        };

        model.canCreatePrototype = function () {
            return model.PrototypeCreate && (model.patternCurrStatusId === 2 || model.patternCurrStatusId === 3);
        };

        /*model.deletePatternSeasonal = function () {
            PatternService.deletePatternSeasonal(model.patternSeasonalId).then(function (deletePatternSeasonalResponse) {
                if (deletePatternSeasonalResponse == 1) {
                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Record Deleted Successfully.',
                        timeout: 5000
                    });
                    $state.go('Search');
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body:
                            'Record was not deleted. Please check current status and make sure there are no prototypes linked.',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while deleting the record. Please contact your administrator.',
                        timeout: 5000
                    });
                }
            );
        };*/

        model.RelinkClicked = function () {
            model.relinkIssuesList = [];
            SeasonService.getProjectsSeasons(model.patternDetails.PatternId, 3).then(function (response) {
                if (response && response.length != 1) {
                    model.relinkIssuesList.push(
                        { "IssueText": "The pattern must exist in only one season to relink" });
                    $('#relinkModal').modal('show');
                }
                if (model.patternPrototypes.length > 0) {
                    model.relinkIssuesList.push({ "IssueText": "The pattern cannot have any linked prototypes" });
                    $('#relinkModal').modal('show');
                } else {
                    model.loadBriefs();
                }
            });
        };

        model.Do_Relink = function () {
            PatternService.relinkPattern(model.patternDetails.PatternId, model.briefId, model.patternBriefs[0].BriefId)
                .then(function (response) {
                    if (response.IsSuccessful) {
                        $state.reload();
                        toaster.pop({
                            type: 'success',
                            title: 'Success!',
                            body: 'Relink succeeded.',
                            timeout: 5000
                        });
                    } else {
                        var msg = typeof response === 'string' ? response : response.Message;

                        toaster.pop({
                            type: 'error',
                            title: 'Error',
                            body: 'Re-link failed. ' + msg,
                            timeout: 5000
                        });
                    }
                });
        };

        model.loadBriefs = function () {
          /*  BriefService.getRelinkList(model.patternSeasonalDetails.PatternSeasonalId)
                .then(function (response) {
                    model.briefsForRelink = response || [];
                })
                .then(function () {
                    $('#relinkModal').modal('show');
                });*/
        };

        model.setBrief = function (briefId, briefStatusId) {
            if (briefStatusId == 2 || briefStatusId == 3) {
                model.briefId = briefId;
                model.radioValue = model.briefId;
            }
        };

        model.loadCarryoverShiftLinePlans = function () {
            model.carryoverShiftLinePlan = null;
            model.carryoverShiftLinePlans = [];
            model.carryoverShiftLinePlanId = 0;

            PatternService.getBriefAndLinePlanForPattern(model.patternDetails.PatternId, model.carryoverShiftSeasonId).then(function (data) {
                if (data.LinePlan && data.Brief) {
                    model.carryoverShiftLinePlan = data.LinePlan;
                    model.carryoverShiftLinePlanId = data.LinePlan.LinePlanId;
                    model.shiftLinePlanChanged();
                } else {
                    LinePlanService.getLinePlansByBrandSeason(model.patternDetails.BrandId, model.carryoverShiftSeasonId, 0).then(function (data) {

                        angular.forEach(data, function (linePlan) {
                            if (linePlan.StatusId !== 1)
                                model.carryoverShiftLinePlans.push(linePlan);
                        });

                        if (data.length === 1) {
                            model.carryoverShiftLinePlanId = data[0].LinePlanId;
                            model.shiftLinePlanChanged();
                        }
                    });
                }
            });
        };

        model.shiftLinePlanChanged = function () {
            if (model.carryoverShiftLinePlanId) {
                model.carryoverShiftMessage = null;
            }
        };

        model.getSeasonsForCarryoverShift = function (brandId, seasonId) {
            model.carryoverShiftSeasons = [];

            SeasonService.getShiftCarryoverSeasonsByBrand(brandId, seasonId).then(function (data) {

                if (data.length > 0) {
                    angular.forEach(data, function (season) {
                        if (season.SeasonId !== model.patternSeasonalDetails.SeasonId)
                            model.carryoverShiftSeasons.push(season);
                    });

                }
                else {
                    toaster.pop({
                        type: 'warning',
                        title: 'Alert!',
                        body: 'No available line plans were found.',
                        timeout: 3000
                    });
                }
            });
        }

        model.StartCarryoverOrShift = function (loadFutureSeasonsOnly) {
            model.carryoverShiftLinePlan = null;
            model.carryoverShiftLinePlans = [];
            model.carryoverShiftSeasonId = 0;
            model.carryoverShiftLinePlanId = 0;
            model.carryoverShiftMessage = "";

            var seasonId = loadFutureSeasonsOnly ? model.patternSeasonalDetails.SeasonId : null;
            model.getSeasonsForCarryoverShift(model.patternDetails.BrandId, seasonId);
        };

        model.Carryover = function () {
            model.carryoverSuccess = false;
            model.carryoverFail = false;
            model.carryoverMessage = "";
            CarryoverService.doPatternCarryover(model.patternSeasonalDetails.PatternSeasonalId, model.carryoverShiftLinePlanId)
                .then(function (response) {
                    model.carryoverSuccess = response.Result === 0;
                    model.carryoverFail = !model.carryoverSuccess;
                    model.carryoverMessage = response.Message;
                    model.canShift = false;

                    model.goToNewPattern = function () {
                        $("#carryoverModal").modal("hide");
                        $state.go("pattern", { patternSeasonalId: response.Data.PatternSeasonalId });
                    };
                },
                    function (response) {
                        model.carryoverSuccess = false;
                        model.carryoverFail = true;
                        model.carryoverMessage = response.Message;
                    });
        };

        model.ShiftSeason = function () {
            CarryoverService.shiftPatternSeason(model.patternDetails.PatternId, model.patternSeasonalDetails.SeasonId, model.carryoverShiftSeasonId, model.carryoverShiftLinePlanId)
                .then(function (response) {
                    getPatternSeasonalDetails();
                    $("#shiftModal").modal("hide");
                    toaster.pop({
                        type: "success",
                        title: "Success!",
                        body: "Season changed successfully.",
                        timeout: 3000
                    });
                },
                    function (response) {
                        toaster.pop({
                            type: "error",
                            title: "Error!",
                            body: response.Message,
                            timeout: 5000
                        });
                    });
        };

        function getSeasonList() {
            var searchObject = {
                PatternId: model.patternDetails.PatternId,
                PageNumber: 1,
                PageSize: 999
            }
            PatternService.searchPatterns(searchObject).then(function (response) {
                if (response.results.length > 0) {
                    model.patternSeasons = response.results;
                }

            },
                function (error, status) {
                    model.prototypes = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was some error while getting Prototype Seasons. Please contact system administrator',
                        timeout: 5000
                    });
                });
        }

        model.closeModal = function() {
            $('#seasonList').modal('hide');
        };

        model.onDevCenterClose = function (hasChanges, patternEditForm) {
            if (hasChanges)
                patternEditForm.$setDirty(true);
        };

        $scope.$watchCollection("vm.selectedDevCenters", function (n, o) {
            model.selectedDevCenters = n;
            $scope.selectedDevCenters = model.selectedDevCenters;
        });
    }
})();
